import {
  FETCH_FOOTER_REQUESTED,
  FETCH_FOOTER_SUCCEEDED,
  FETCH_FOOTER_FAILED,
} from './actionTypes'

export function fetchFooterRequested (params) {
  return {
    type: FETCH_FOOTER_REQUESTED,
    payload: params,
  }
}

export function fetchFooterSucceeded (oneLinkParams = {}) {
  return {
    type: FETCH_FOOTER_SUCCEEDED,
    payload: oneLinkParams,
  }
}

export function fetchFooterFailed (error) {
  return {
    type: FETCH_FOOTER_FAILED,
    payload: error,
    error: true,
  }
}



// WEBPACK FOOTER //
// ./src/store/footer/action.js